// extracted by mini-css-extract-plugin
export default {"filter-table-header":"table-filter-header_filter-table-header__7d2Z7"};